import { render, staticRenderFns } from "./Returns.vue?vue&type=template&id=845c899e"
import script from "./Returns.vue?vue&type=script&lang=js"
export * from "./Returns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports